import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
 
import { Observable } from 'rxjs';
import { Invitations } from '../entity/invitation';
 
 



 

const httpOptions = {
  responseType: 'blob' as 'json',
  headers: new HttpHeaders({
      'Accept': 'application/pdf',
      'Content-Type': 'application/pdf'
  })
};
@Injectable()
export class InvitationVisaService {

  private baseUrl = environment.restApi;
 // private baseUrlOnline = environment.restApiOnline;
  private invitationsUrl = `${this.baseUrl}invitations`;
 
  constructor(   private http: HttpClient, ) {
  }

  /** 
   * GET: get all exhibitors from the database 
   */
  getByExhibitor(idClient:number): Observable<any> {

      return this.http
          .get<Invitations[]>(this.invitationsUrl+'/findByExhibitor/'+idClient) ;
  }

  getAll(): Observable<Invitations[]> {
    return this.http.get<Invitations[]>(this.invitationsUrl);
  }
  findByType(type:string): Observable<Invitations[]> {
    //  findByType/{type}
    return this.http.get<Invitations[]>(this.invitationsUrl+'/findByType/'+type);
  }


  printInvitations(type: string,isSignature: boolean, typeInvitation: string, idInviation: number): any {
    // /{type}/{isSigner}/{isEntet}/{clientId}
 
    
            return this.http.put(this.invitationsUrl + `/printInvitations/${type}/${isSignature}/${typeInvitation}/${idInviation}`,  '', { responseType: "blob"})  ;
        }
    
 
        updateInvitations(invitations: Invitations): Observable<any> {
          return this.http
              .put(`${this.invitationsUrl}/${invitations.id_invitation}`, invitations ) ;
      }
}
